export default __webpack_public_path__ + "static/assets/med_x_ampoule_2_mask.cdd7682c.png";